/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNavigatingToTile = exports.getProgramMatchingTime = exports.getNextProgramUp = exports.getNextProgramDown = exports.getFocusInfo = void 0;
var _coordinateUtils = require("./coordinateUtils");
var getProgramMatchingTime = function getProgramMatchingTime(channel, pStart, pEnd) {
  if (!channel || !channel.programs) {
    return undefined;
  }
  var chosen;
  channel.programs.forEach(function (p) {
    if (p.startTime <= pStart && p.endTime >= pEnd) {
      chosen = p;
    } else if (p.startTime >= pStart && p.endTime <= pEnd) {
      chosen = p;
    } else if (p.startTime >= pStart && p.startTime <= pEnd && !chosen) {
      chosen = p;
    } else if (p.endTime >= pStart && p.endTime <= pEnd && !chosen) {
      chosen = p;
    }
  });
  return chosen;
};
exports.getProgramMatchingTime = getProgramMatchingTime;
var getNextProgramDown = function getNextProgramDown(channels, cIndex, pStart, pEnd) {
  var nextIndex = cIndex + 1;
  if (!channels || channels.length <= nextIndex) {
    return undefined;
  }
  var nextChannel = channels[nextIndex];
  var nextProgram = getProgramMatchingTime(nextChannel, pStart, pEnd);
  if (nextProgram) {
    return {
      nextProgram: nextProgram,
      nextChannelIndex: nextIndex
    };
  }
  return getNextProgramDown(channels, nextIndex, pStart, pEnd);
};
exports.getNextProgramDown = getNextProgramDown;
var getNextProgramUp = function getNextProgramUp(channels, cIndex, pStart, pEnd) {
  var nextIndex = cIndex - 1;
  if (!channels || nextIndex < 0) {
    return undefined;
  }
  var nextChannel = channels[nextIndex];
  var nextProgram = getProgramMatchingTime(nextChannel, pStart, pEnd);
  if (nextProgram) {
    return {
      nextProgram: nextProgram,
      nextChannelIndex: nextIndex
    };
  }
  return getNextProgramUp(channels, nextIndex, pStart, pEnd);
};
exports.getNextProgramUp = getNextProgramUp;
var getFocusInfo = function getFocusInfo(_ref) {
  var channels = _ref.channels,
    coordinate = _ref.coordinate,
    transitionInfo = _ref.transitionInfo,
    _ref$getProgramMatchi = _ref.getProgramMatchingTimeFn,
    getProgramMatchingTimeFn = _ref$getProgramMatchi === void 0 ? getProgramMatchingTime : _ref$getProgramMatchi;
  try {
    var x = coordinate.x,
      y = coordinate.y;
    var fromX = coordinate.x,
      fromY = coordinate.y;
    var channelIndex = -1;
    var programIndex = 0;
    var selectedProgram;
    if (transitionInfo) {
      var channelId = transitionInfo.channelId,
        fromCoordinate = transitionInfo.fromCoordinate,
        toCoordinate = transitionInfo.toCoordinate;

      // If we get a channelId in the transition info, we'll check
      // if this ID matches any of the tile's channels.
      channelIndex = channels.findIndex(function (c) {
        return c.channelId === channelId;
      });
      if (!(0, _coordinateUtils.areEqual)(toCoordinate, coordinate)) {
        return null;
      }
      if (fromCoordinate) {
        fromX = fromCoordinate.x;
        fromY = fromCoordinate.y;
      }
    }

    // If we haven't yet found the channel to focus,
    // we'll select either the first or last channel of the tile
    // depending on from which direction we're navigating.
    if (channelIndex < 0) {
      channelIndex = fromY > y ? channels.length - 1 : 0;
    }
    var selectedChannel = channels && channels[channelIndex];
    if (!selectedChannel || !selectedChannel.programs || !selectedChannel.programs.length) {
      return null;
    }
    if (transitionInfo && transitionInfo.program) {
      var _transitionInfo$progr = transitionInfo.program,
        startTime = _transitionInfo$progr.startTime,
        endTime = _transitionInfo$progr.endTime;

      // Find the program best matching the time of the program
      // which we are navigating from.
      selectedProgram = getProgramMatchingTimeFn(selectedChannel, startTime, endTime);
    }
    var fromRight = fromX > x;
    if (fromRight && selectedChannel.programs) {
      programIndex = selectedChannel.programs.length - 1;
    }
    selectedProgram = selectedProgram || selectedChannel.programs[programIndex];

    // If we're navigating from another tile and we find that the next
    // program to focus has the same program ID as the one we came from,
    // we'll select the next program in the given direction.
    if (transitionInfo && transitionInfo.program && selectedProgram.id === transitionInfo.program.id) {
      var newIndex = fromRight ? programIndex - 1 : programIndex + 1;
      selectedProgram = selectedChannel.programs.length > newIndex ? selectedChannel.programs[newIndex] : null;
    }
    return {
      program: selectedProgram,
      channelIndex: channelIndex
    };
  } catch (err) {
    console.log('Failed to get focus program', err);
    return null;
  }
};
exports.getFocusInfo = getFocusInfo;
var isNavigatingToTile = function isNavigatingToTile(currentProps) {
  var transitionInfo = currentProps.transitionInfo,
    coordinate = currentProps.coordinate;
  var _ref2 = transitionInfo || {},
    toCoordinate = _ref2.toCoordinate;
  return toCoordinate && (0, _coordinateUtils.areEqual)(coordinate, toCoordinate);
};
exports.isNavigatingToTile = isNavigatingToTile;